import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	childIssueAlreadyLinkedNoReplaceTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	childIssueAlreadyLinkedNoReplaceDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	childIssueAlreadyLinkedNoReplaceAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noProjectEditPermsErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	childIssueAlreadyLinkedNoReplaceTitle: {
		id: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project.title',
		defaultMessage: "Can't link project",
		description: 'Title for the error flag when child issues are linked to another project',
	},
	childIssueAlreadyLinkedNoReplaceDescription: {
		id: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project.description',
		defaultMessage:
			"This work item has child items linked to another project. Since you don't have permission to edit those child items, this project can't be linked here. ",
		description: 'Description for the error flag when child issues are linked to another project',
	},
	childIssueAlreadyLinkedNoReplaceAction: {
		id: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.child-issue-already-linked-to-another-project.action',
		defaultMessage: 'More on project inheritance',
		description: 'Action text for the error flag when child issues are linked to another project',
	},
	noProjectEditPermsErrorMessage: {
		id: 'issue-field-atlas-project-inline-edit-full.ui.atlas-project.show-flag.error.no-project-edit-perms.message',
		defaultMessage: 'You need edit permission on the project to link it to this work item.',
		description: 'Error message when user does not have permission to edit a project',
	},
});
export default messages;
